// extracted by mini-css-extract-plugin
module.exports = {"list":"LineList_list__3pwX0","value":"LineList_value__3Gncw"};